import { DeviceContextData } from './DeviceContextData';

export default class ContextDataFactory {
	static createDeviceContextData() {
		return new DeviceContextData();
	}
}
